import DocumentCreationButton from 'Components/DocumentCreationButton';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import DescriptionText from 'Routes/Cognition/utils/DescriptionText';
import { formatPartialDate } from 'Utility/date';

const TMT = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id="cognition.tmt.tmtLong" />}
      newButton={
        <DocumentCreationButton
          name="tmt"
          text="cognition.tmt.newTmt"
          onClick={startEdit({}, 'tmt')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
      headerInfoText={<DescriptionText type={'tmt'} />}
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={2}>
              <FormattedMessage id="general.date" />
            </Item>
            <Item xs={4}>
              <FormattedMessage id="cognition.tmt.tmta" />
            </Item>
            <Item xs={3}>
              <FormattedMessage id="cognition.tmt.tmtb" />
            </Item>
            <Item xs={3}>&nbsp;</Item>
          </>
        }
        contentFormat={d => (
          <>
            <Item xs={2}>{formatPartialDate(d.date ?? undefined)}</Item>
            <Item xs={4}>
              {d.tmtaUnableToPerform?.[0] === 'unableToPerform' ? (
                <FormattedMessage id="cognition.tmt.unableToPerform" />
              ) : (
                <FormattedMessage id="cognition.tmt.tmtSeconds" values={{ seconds: d.tmtaTime }} />
              )}
            </Item>
            <Item xs={3}>
              {d.tmtbUnableToPerform?.[0] === 'unableToPerform' ? (
                <FormattedMessage id="cognition.tmt.unableToPerform" />
              ) : d.tmtbTime ? (
                <FormattedMessage id="cognition.tmt.tmtSeconds" values={{ seconds: d.tmtbTime }} />
              ) : (
                '-'
              )}
            </Item>
            <Item xs={3}>
              <HistoryRowControls document={d} startEdit={startEdit} view={view} />
            </Item>
          </>
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'tmt'>[];
  startEdit: StartEdit;
  view?: IView;
}

export default TMT;
